import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverContentWidthConstantType,
    PopoverContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    POPOVER_SIZE_RATIOS
} from "../../util";
import {
    webStyle
} from "../../../../utils";

export const POPOVER_CONTENT_TITLE_VARIANT = "titleSmallSize";

export const POPOVER_CONTENT_DESCRIPTION_VARIANT = "bodyMediumSize";

export const getPopoverContentWidth = ({
    shapeConfigs,
    size
}: PopoverContentWidthConstantType): number => {
    return shapeConfigs.sideListWidth * POPOVER_SIZE_RATIOS[size];
};

const stylesheet = StyleSheet.create({
    header: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    content: {
        flexDirection: "column",
        flexShrink: 1,
        minHeight: 0,
        minWidth: 0
    },
    headerText: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    },
    sheetBody: {
        flexDirection: "column"
    },
    body: {
        flexShrink: 1,
        minHeight: 0
    }
});

export const useStyles = ({
    borders,
    spaces
}: PopoverContentDynamicStyleType) => {
    const focusRingRoom = borders.focus * 2;

    const styles = {
        body: {
            marginBottom: spaces.spacingXs - focusRingRoom,
            marginHorizontal: -focusRingRoom,
            marginTop: -focusRingRoom,
            ...webStyle({
                scrollbarGutter: "auto"
            })
        } as Mutable<ViewStyle>,
        sheetBody: {
            paddingHorizontal: spaces.spacingLg,
            paddingVertical: spaces.spacingMd,
            gap: spaces.spacingMd
        },
        bodyContent: {
            padding: focusRingRoom,
            gap: spaces.spacingMd
        },
        headerText: {
            gap: spaces.spacingSm
        },
        header: {
            gap: spaces.spacingSm
        },
        content: {
            gap: spaces.spacingMd
        }
    };

    return styles;
};
export default stylesheet;
